import { render, staticRenderFns } from "./PertanyaanContentMobile.vue?vue&type=template&id=4984ff48&scoped=true"
import script from "./PertanyaanContentMobile.vue?vue&type=script&lang=js"
export * from "./PertanyaanContentMobile.vue?vue&type=script&lang=js"
import style0 from "./PertanyaanContentMobile.vue?vue&type=style&index=0&id=4984ff48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984ff48",
  null
  
)

export default component.exports